export default __webpack_public_path__ + "static/media/img-time-l-dot.3362340c.svg";